/**
 * Job status constants matching the legacy system
 */
export const JOB_STATUS = {
  POSTED: 1,      // Unfilled/Posted (Red/Coral) - looking for a temp
  PARTIAL: 2,     // Custom/Partial (Blue) - has partial offers to review (alias for CUSTOM)
  CUSTOM: 2,      // Custom/Partial (Blue) - has partial offers to review
  BOOKED: 3,      // Booked/Confirmed (Green) - temp is confirmed
  CONFIRMED: 3,   // Booked/Confirmed (Green) - temp is confirmed (alias for BOOKED)
  COMPLETED: 4,   // Completed (Green) - shift is done
  EXPIRED: 5,     // Expired (Red/Coral) - shift date passed without booking
  OFFER_EXPIRED: 5 // Offer Expired (Red/Coral) - offers expired (alias for EXPIRED)
} as const;

export type JobStatusType = typeof JOB_STATUS[keyof typeof JOB_STATUS];

/**
 * Status display names
 */
export const JOB_STATUS_NAMES: Record<number, string> = {
  1: 'Posted',
  2: 'Custom Offers',
  3: 'Booked',
  4: 'Completed',
  5: 'Expired'
};

/**
 * Status colors for UI display
 */
export const JOB_STATUS_COLORS: Record<number, string> = {
  1: 'var(--primary-main, #FB7672)',     // Coral/Red
  2: 'var(--primary-blue, #0B4598)',     // Blue
  3: 'var(--success-main, #13CA82)',     // Green
  4: 'var(--success-main, #13CA82)',     // Green
  5: '#9CA3AF'                           // Grey (expired de-emphasized, T2-6116)
}; 